import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  headerRow: {
    border: '1px #D1D1D1 solid'
  }
};

const enhance = compose();

const UserTableHead = enhance(({ order, orderBy, onRequestSort, classes }) => {
  return (
    <TableHead>
      <TableRow className={classes.headerRow}>
        <TableCell sortDirection={orderBy === 'shopId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopId'}
            direction={order}
            onClick={() => {
              onRequestSort('shopId');
            }}
          >
            領収書No
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopName'}
            direction={order}
            onClick={() => {
              onRequestSort('shopName');
            }}
          >
            メニューID
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuId'}
            direction={order}
            onClick={() => {
              onRequestSort('menuId');
            }}
          >
            メニュー名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuName'}
            direction={order}
            onClick={() => {
              onRequestSort('menuName');
            }}
          >
            発行日
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuChildType' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuChildType'}
            direction={order}
            onClick={() => {
              onRequestSort('menuChildType');
            }}
          >
            価格
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'price' ? order : false}>
          <TableSortLabel
            active={orderBy === 'price'}
            direction={order}
            onClick={() => {
              onRequestSort('price');
            }}
          >
            個数
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
          <TableSortLabel
            active={orderBy === 'taxTypeStr'}
            direction={order}
            onClick={() => {
              onRequestSort('taxTypeStr');
            }}
          >
            決済金額
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
          <TableSortLabel
            active={orderBy === 'taxTypeStr'}
            direction={order}
            onClick={() => {
              onRequestSort('taxTypeStr');
            }}
          >
            予算対象月
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
          <TableSortLabel
            active={orderBy === 'taxTypeStr'}
            direction={order}
            onClick={() => {
              onRequestSort('taxTypeStr');
            }}
          >
            ごちURL
          </TableSortLabel>
        </TableCell>
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(UserTableHead);
